/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Delete_Terms_Title_ConfirmInputs */

const en_knp_lookup_delete_terms_title_confirm = /** @type {(inputs: Knp_Lookup_Delete_Terms_Title_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Terms?`)
};

const fr_knp_lookup_delete_terms_title_confirm = /** @type {(inputs: Knp_Lookup_Delete_Terms_Title_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer des termes ?`)
};

const de_knp_lookup_delete_terms_title_confirm = /** @type {(inputs: Knp_Lookup_Delete_Terms_Title_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzungsbedingungen löschen?`)
};

const it_knp_lookup_delete_terms_title_confirm = /** @type {(inputs: Knp_Lookup_Delete_Terms_Title_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminare i termini?`)
};

const ru_knp_lookup_delete_terms_title_confirm = /** @type {(inputs: Knp_Lookup_Delete_Terms_Title_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить условия?`)
};

const es_knp_lookup_delete_terms_title_confirm = /** @type {(inputs: Knp_Lookup_Delete_Terms_Title_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Eliminar términos?`)
};

const zh_cn2_knp_lookup_delete_terms_title_confirm = /** @type {(inputs: Knp_Lookup_Delete_Terms_Title_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除条款？`)
};

const ja_knp_lookup_delete_terms_title_confirm = /** @type {(inputs: Knp_Lookup_Delete_Terms_Title_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用規約を削除しますか?`)
};

const hi_knp_lookup_delete_terms_title_confirm = /** @type {(inputs: Knp_Lookup_Delete_Terms_Title_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शर्तें हटाएं?`)
};

const pt_pt2_knp_lookup_delete_terms_title_confirm = /** @type {(inputs: Knp_Lookup_Delete_Terms_Title_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir termos?`)
};

/**
* | output |
* | --- |
* | "Delete Terms?" |
*
* @param {Knp_Lookup_Delete_Terms_Title_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_delete_terms_title_confirm = /** @type {((inputs?: Knp_Lookup_Delete_Terms_Title_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Delete_Terms_Title_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_delete_terms_title_confirm(inputs)
	if (locale === "de") return de_knp_lookup_delete_terms_title_confirm(inputs)
	if (locale === "it") return it_knp_lookup_delete_terms_title_confirm(inputs)
	if (locale === "ru") return ru_knp_lookup_delete_terms_title_confirm(inputs)
	if (locale === "es") return es_knp_lookup_delete_terms_title_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_delete_terms_title_confirm(inputs)
	if (locale === "ja") return ja_knp_lookup_delete_terms_title_confirm(inputs)
	if (locale === "hi") return hi_knp_lookup_delete_terms_title_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_delete_terms_title_confirm(inputs)
	return en_knp_lookup_delete_terms_title_confirm(inputs)
});